function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:url(#RedGradient);}.cls-2{fill:#fff;}"), React.createElement("linearGradient", {
  id: "RedGradient",
  x1: -15.53,
  y1: 90.53,
  x2: 90.53,
  y2: -15.53,
  gradientTransform: "translate(0 0)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#bd0816"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ff5252"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-GuardDuty");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Red_Gradient",
  "data-name": "Red Gradient",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Icon_Test",
  "data-name": "Icon Test"
}, React.createElement("path", {
  className: "cls-2",
  d: "M42.27,62.5H32.73a1,1,0,0,1-.73-.31,1,1,0,0,1-.27-.75l.18-3.14a21.39,21.39,0,0,1-5.16-2.14l-2.1,2.35a1,1,0,0,1-.72.33,1,1,0,0,1-.73-.29L16.45,51.8a1,1,0,0,1-.29-.73,1,1,0,0,1,.33-.72l2.35-2.1a21.36,21.36,0,0,1-2.13-5.16l-3.15.18a1,1,0,0,1-.75-.27,1,1,0,0,1-.31-.73V32.73a1,1,0,0,1,.31-.73,1,1,0,0,1,.75-.27l3.16.18a21.09,21.09,0,0,1,2.14-5.15l-2.37-2.11a1,1,0,0,1-.33-.72,1,1,0,0,1,.29-.73l6.75-6.75a1,1,0,0,1,.73-.29,1,1,0,0,1,.72.33l2.11,2.36a21.45,21.45,0,0,1,5.15-2.13l-.18-3.16a1,1,0,0,1,.27-.75,1,1,0,0,1,.73-.31h9.54a1,1,0,0,1,.73.31,1,1,0,0,1,.27.75l-.18,3.16a21.48,21.48,0,0,1,5.15,2.14l2.11-2.37a1,1,0,0,1,.72-.33,1.05,1.05,0,0,1,.73.29l6.75,6.75a1,1,0,0,1,.29.73,1,1,0,0,1-.33.72l-2.36,2.1a21.55,21.55,0,0,1,2.14,5.16l3.15-.18a1,1,0,0,1,.75.27,1,1,0,0,1,.31.73v9.54a1,1,0,0,1-.31.73,1.07,1.07,0,0,1-.75.27l-3.15-.18a21.15,21.15,0,0,1-2.14,5.16l2.36,2.1a1,1,0,0,1,.33.72,1,1,0,0,1-.29.73L51.8,58.55a1,1,0,0,1-.73.29,1,1,0,0,1-.72-.33l-2.09-2.35a21.22,21.22,0,0,1-5.17,2.14l.18,3.14a1,1,0,0,1-.27.75A1,1,0,0,1,42.27,62.5Zm-8.48-2h7.42L41,57.59a1,1,0,0,1,.78-1A19.54,19.54,0,0,0,47.92,54a1,1,0,0,1,1.28.18l1.94,2.18,5.25-5.25-2.19-2A1,1,0,0,1,54,47.91a19.12,19.12,0,0,0,2.52-6.09,1,1,0,0,1,1-.78l2.93.17V33.79L57.57,34a1,1,0,0,1-1-.78A19.58,19.58,0,0,0,54,27.09a1,1,0,0,1,.18-1.28l2.19-1.95-5.25-5.25-2,2.2A1,1,0,0,1,47.9,21a19.53,19.53,0,0,0-6.08-2.52,1,1,0,0,1-.78-1l.17-2.94H33.79L34,17.44a1,1,0,0,1-.78,1A19.41,19.41,0,0,0,27.1,21a1,1,0,0,1-1.28-.18l-2-2.19-5.25,5.25,2.2,2A1,1,0,0,1,21,27.1a19.32,19.32,0,0,0-2.53,6.08,1,1,0,0,1-1,.78l-2.93-.17v7.42L17.42,41a1,1,0,0,1,1,.78A19.39,19.39,0,0,0,21,47.91a1,1,0,0,1-.18,1.28l-2.18,2,5.25,5.25,1.95-2.18A1,1,0,0,1,27.09,54a19.37,19.37,0,0,0,6.09,2.53,1,1,0,0,1,.78,1Zm3.71-7.82c-11.86,0-12-12.62-12-12.75V27a1,1,0,0,1,.62-.92l11-4.54a.92.92,0,0,1,.76,0l11,4.54a1,1,0,0,1,.62.92V40C49.5,40.09,49.36,52.68,37.5,52.68Zm-10-25V39.93c0,.44.15,10.75,10,10.75S47.5,40.4,47.5,40V27.71l-10-4.13Zm10,20.86c-6.35,0-7.92-7.84-8-8.18a1.1,1.1,0,0,1,0-.18V30.33a1,1,0,0,1,.63-.93l7-2.83a1,1,0,0,1,.74,0l7,2.83a1,1,0,0,1,.63.93v9.88a1.1,1.1,0,0,1,0,.18C45.42,40.73,43.85,48.57,37.5,48.57ZM38.5,29V46.47c3.64-.77,4.85-5.67,5-6.37V31Zm-7,11.12c.16.7,1.38,5.59,5,6.37V29l-5,2Z"
})));

var SvgAwsGuardDuty = function SvgAwsGuardDuty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsGuardDuty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-GuardDuty.ba621dd4.svg";
export { ForwardRef as ReactComponent };